// Platform tags (TikTok, Shopify…): a managed list in the naming-convention sheet of the Export tab. Stored in
// localStorage and synced server-side through the shared workspace (SHARED_KEYS here + ALLOWED_KEYS in backend/workspace.js).
// A tag is { id, label, suffix, active }. `active` is global (every file of the export), off by default.
// `suffix` is what an active tag appends to the creative name (v1 behaviour of the two built-ins, kept as-is);
// a tag added from the sheet has no suffix, so it never touches a name.
export const LS_PLATFORM_TAGS = 'timbo_export_platform_tags_v1';

export const DEFAULT_PLATFORM_TAGS = [
  { id: 'tiktok',  label: 'TikTok',  suffix: 'TikTok',     active: false },
  { id: 'shopify', label: 'Shopify', suffix: 'ShopifyVid', active: false },
];

const clean = (t) => (t && typeof t.id === 'string' && typeof t.label === 'string' && t.label.trim())
  ? { id: t.id, label: t.label.trim(), suffix: typeof t.suffix === 'string' ? t.suffix : '', active: !!(t.active ?? t.shown) } : null;

export function getPlatformTags() {
  try {
    const saved = JSON.parse(localStorage.getItem(LS_PLATFORM_TAGS));
    if (Array.isArray(saved)) { const ok = saved.map(clean).filter(Boolean); if (ok.length) return ok; }
  } catch {}
  return DEFAULT_PLATFORM_TAGS.map(t => ({ ...t }));
}
export function savePlatformTags(list) { try { localStorage.setItem(LS_PLATFORM_TAGS, JSON.stringify(list)); } catch {} }

// Suffix appended to the creative name by the active tags that carry one.
export const tagSuffix = (tags) => (tags || []).filter(t => t.active && t.suffix).map(t => t.suffix).join('');

// Id for a tag added from the sheet: slug of its label, unique within the list.
export function newTagId(label, tags) {
  const base = (label || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'tag';
  let id = base, n = 2;
  while (tags.some(t => t.id === id)) id = `${base}-${n++}`;
  return id;
}
